import store from "store";
import { decryptData } from "utilities/Store_data";
import { USER_ENCRYPTION_KEY } from "constants/app.constant";

export function isOutOfStockSaleFlag(value) {
  return String(value ?? "")
    .trim()
    .toUpperCase() === "Y";
}

export function resolveOutOfStockSaleFromLoginData(data) {
  if (!data) {
    return false;
  }

  const candidates = [
    data.out_of_stock_sale,
    data.out_of_stocks_sale,
    data.pos_udaan?.out_of_stock_sale,
    data.client?.out_of_stock_sale,
    data.client_settings?.out_of_stock_sale,
  ];

  return candidates.some(isOutOfStockSaleFlag);
}

export function allowsOutOfStockSale(userData) {
  try {
    if (store.getState()?.invice?.cart?.allowOutOfStockSale) {
      return true;
    }
  } catch {
    // ignore store read errors
  }

  if (userData != null) {
    return resolveOutOfStockSaleFromLoginData(userData);
  }

  try {
    const encrypted = store.getState()?.auth?.user;
    if (!encrypted) {
      return false;
    }
    const user = decryptData(encrypted, USER_ENCRYPTION_KEY);
    return resolveOutOfStockSaleFromLoginData(user);
  } catch {
    return false;
  }
}

export function isCartQuantityAtStockLimit(
  cartQty,
  availableQty,
  allowOutOfStockSale = allowsOutOfStockSale()
) {
  if (allowOutOfStockSale) {
    return false;
  }

  const available = parseInt(availableQty || 0, 10);
  const qty = parseInt(cartQty || 0, 10);
  return available > 0 && qty >= available;
}

export function isQuantityOverAvailable(cartQty, availableQty) {
  const qty = parseInt(cartQty, 10);
  const available = parseInt(availableQty, 10);

  if (Number.isNaN(qty) || Number.isNaN(available)) {
    return false;
  }

  return qty > available;
}
